import { UIMetadataComplete } from '../types/UIMetadata';

export const linkId =
  (import.meta.env?.VITE_LINK_ID as string | undefined) ||
  (process.env.VITE_LINK_ID as string | undefined) ||
  '2378';

// Eagerly import all available metadata using Vite's import.meta.glob so the
// correct client's data is selected at runtime based on linkId.
const allGraphicsMetadata = import.meta.glob('../assets/jsons/*/graphics-metadata.ts', {
  eager: true,
}) as Record<string, { metadata: unknown }>;

const allUIMetadata = import.meta.glob('../assets/jsons/*/ui-metadata.ts', {
  eager: true,
}) as Record<string, { uimetadata: UIMetadataComplete }>;

const graphicsKey = `../assets/jsons/${linkId}/graphics-metadata.ts`;
const uiKey = `../assets/jsons/${linkId}/ui-metadata.ts`;

export const metadata = allGraphicsMetadata[graphicsKey]?.metadata;
export const uimetadata = allUIMetadata[uiKey]?.uimetadata as UIMetadataComplete;

/** Base URL string for assets, respects Vite's configured base path. */
export const assetUrl = import.meta.env.BASE_URL.replace(/\/?$/, '/') + 'assets/';

/** Resolve asset paths relative to /assets/ in the public folder.
 *  Paths in ui-metadata already include the linkId folder, e.g.
 *  'images/2378/var_Z71.png' → '/assets/images/2378/var_Z71.png'
 */
export const assetSrc = (path: string): string => `${assetUrl}${path}`;
